import React, { createContext, useContext, useState, useEffect } from 'react';

const TokensContext = createContext();

export const TokensProvider = ({ children }) => {
    const [tokens, setTokens] = useState(0);

    const fetchTokens = async () => {
        const userId = localStorage.getItem('fw_user');
        if (!userId) return;

        try {
            const response = await fetch(`https://api.fantasyworldtrpg.cz/casino-api/gettokens.php?user_id=${userId}`);
            const data = await response.json();

            if (data.casino_coins !== undefined) {
                setTokens(data.casino_coins);
                localStorage.setItem('tokens', data.casino_coins);
            } else {
                console.error('Tokeny nebyly načteny:', data.error);
            }
        } catch (error) {
            console.error('Chyba při načítání tokenů:', error);
        }
    };

    useEffect(() => {
        fetchTokens();
    }, []);

    return (
        <TokensContext.Provider value={{ tokens, setTokens, fetchTokens }}>
            {children}
        </TokensContext.Provider>
    );
};

export const useTokens = () => useContext(TokensContext);
